import { ConfigProvider, ConfigProviderProps } from 'antd';
import React from 'react';

import { useCurrentLocale } from '../hooks/useCurrentLocale';

export function I18nConfigProvider(props: ConfigProviderProps) {
  const { children, ...rest } = props;
  const { antdLocale } = useCurrentLocale();

  return (
    <ConfigProvider locale={antdLocale} {...rest}>
      {children}
    </ConfigProvider>
  );
}
